/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Minus } from '../../assets/themes/OPL/img/icons/Minus.svg';

function RemoveButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Minus}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

RemoveButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default RemoveButton;
